

















import { Component, Prop, Vue } from 'vue-property-decorator';
import TaskComponent,{ Task } from '@/components/Task.vue';

@Component({
    components: {
        task: TaskComponent,
    }
})
export default class DayOverview extends Vue {
  @Prop() private type!: string;
  @Prop() private tasks!: Task[];
}
